import * as React from 'react';
type IconExigenciasAduanerasProps = React.SVGProps<SVGSVGElement>;

export const IconExigenciasAduaneras: React.FC<IconExigenciasAduanerasProps> = (props) => (
	<svg
		width={60}
		height={61}
		viewBox="0 0 60 61"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M36.7922 34.2105C36.7922 27.9692 41.8518 22.9097 48.0931 22.9097C54.3343 22.9097 59.3939 27.9692 59.3939 34.2105V57.1515C59.3939 58.6065 58.2144 59.786 56.7594 59.786H39.4267C37.9717 59.786 36.7922 58.6065 36.7922 57.1515V34.2105Z"
			fill="#EBF8F0"
		/>
		<path
			d="M8.14764 52.2445H34.0905V57.3728C34.0905 58.7056 33.01 59.7861 31.6772 59.7861H10.5609C9.22811 59.7861 8.14764 58.7056 8.14764 57.3728V52.2445Z"
			fill="#7EAE90"
		/>
		<path
			d="M8.14764 26L8.14764 51.9429L3.0194 51.9429C1.68658 51.9429 0.606113 50.8624 0.606113 49.5296L0.606114 28.4133C0.606114 27.0805 1.68658 26 3.0194 26L8.14764 26Z"
			fill="#7EAE90"
		/>
		<rect
			x="48.6587"
			y="29.2616"
			width="30.2405"
			height="8.23283"
			rx="4.11642"
			transform="rotate(129.725 48.6587 29.2616)"
			fill="#EBF8F0"
		/>
		<path
			d="M38.1349 9.1468H57.6248V14.0193C57.6248 19.177 53.4436 23.3582 48.2859 23.3582H47.4738C42.3161 23.3582 38.1349 19.177 38.1349 14.0193V9.1468Z"
			fill="#FFA692"
		/>
		<path
			d="M34.2394 1.35821C33.9099 0.871196 34.2588 0.213943 34.8468 0.213943H56.8913C57.2963 0.213943 57.6246 0.542278 57.6246 0.9473V6.38325C57.6246 6.78827 57.2963 7.11661 56.8913 7.11661H38.5241C38.2806 7.11661 38.053 6.9958 37.9166 6.79416L34.2394 1.35821Z"
			fill="#EBF8F0"
		/>
		<path
			d="M34.2394 12.875C33.9099 13.362 34.2588 14.0192 34.8468 14.0192H56.8913C57.2963 14.0192 57.6246 13.6909 57.6246 13.2859V7.84993C57.6246 7.44491 57.2963 7.11658 56.8913 7.11658H38.5241C38.2806 7.11658 38.053 7.23739 37.9166 7.43903L34.2394 12.875Z"
			fill="#EBF8F0"
		/>
		<path
			d="M37.7289 7.11659H57.2187"
			stroke="#7EAE90"
			stroke-width="2.0302"
			stroke-linecap="round"
		/>
		<path
			d="M58.3992 24.0992L37.9818 59.3358"
			stroke="#7EAE90"
			stroke-width="2.63451"
			stroke-linecap="round"
		/>
	</svg>
);

export default IconExigenciasAduaneras;
